import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    loadCoreStatuses: () =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'corestatus/list',
                    method: 'POST',
                    types: [
                        types.LIST_CORESTATUS_REQUEST,
                        types.LIST_CORESTATUS_SUCCESS,
                        types.LIST_CORESTATUS_FAILURE
                    ]
            }
        });
    }
}
